import React, { useEffect, useState } from 'react';

import { Card, Button, Modal } from 'react-bootstrap';
import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Bookings.scss';
import PageTable from '../../Shared/PageTable/PageTable';
import FilterSelector from '../../Shared/FilterSelector/FilterSelector';
import { useHistory } from "react-router-dom";
import DateFormatter from '../../Shared/DateFormatter/DateFormatter';
import InvoiceSender from '../../Shared/InvoiceSender/InvoiceSender';

function Bookings(props) {
    const auth = useAuth();
    const t = useTranslate();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const history = useHistory();
    // const today = new Date();
    // const currentDate = today.getFullYear() + "" + ((today.getMonth() + 1) <= 9 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1)) + "" + today.getDate();

    const handleCloseDeleteModal = () => setShowDeleteModal(false);
    const [bookingsFilter, setBookingsFilter] = useState([]);

    const [loading, setLoading] = useState<boolean>(false);

    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const notifyWarning = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "warning-toast"
    });


    const [deleteBooking, setDeleteBooking] = useState({});
    const [allBookings, setAllBookings] = useState<Array<Object>>([]);
    const [allDeals, setAllDeals] = useState<Array<Object>>([]);
    const [allResources, setAllResources] = useState<Array<Object>>([]);
    const [selectedItems, setSelectedItems] = useState<any>([]);
    const [customers, setCustomers] = useState<any>([]);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [updateTable, setUpdateTable] = useState(0);
    const [showInvoiceSendModal, setShowInvoiceSendModal,] = useState(false);
    const [forceUpdate, setForceUpdate] = useState(0);

    const handleShowNewBooking = () => {
        history.push("/booking");
    };

    const handleShowDeleteModal = (dataLine, evt) => {
        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();

        let hasReservedResources:any = [] ;
        allResources.forEach(item=> {
            let foundAttachedResource = item["bookings"].find(booking => booking["bookingId"] == dataLine["_id"]);
            let isReserved = item["bookings"].find(booking => booking["bookingId"] == dataLine["_id"] && booking["bookingtimes"].length != 0);
            if(isReserved != undefined)  hasReservedResources.push(foundAttachedResource);
        });

        if(hasReservedResources.length != 0) {
            notifyWarning(t("booking.toast_resourcesexist")); 
            return undefined;
        }
        setDeleteBooking(dataLine);
        setShowDeleteModal(true);
    };

    function handleDeleteBooking() {
        axios.delete('/api/bookings/' + deleteBooking["_id"], {
            id: deleteBooking["_id"]
        }, {
            headers: { 'x-access-token': auth.user["token"] }
        })
        .then(res => {
            fetchData();
            notifySuccess(t("bookings.toast_booking_deleted"));
            handleCloseDeleteModal();
            setUpdateTable(updateTable + 1);
        });
    }

    function fetchData() {
        setLoading(true);
        axios.all([
            axios.single({
                method: "get",
                url: "/api/bookings",
                responseType: "json",
                headers: { 'x-access-token': auth.user["token"] }
            }),
            axios.single({
                method: "get",
                url: "/api/deals",
                responseType: "json",
                headers: { 'x-access-token': auth.user["token"] }
            }),
            axios.single({
                method: "get",
                url: "/api/resources",
                responseType: "json",
                headers: { 'x-access-token': auth.user["token"] }
            }),
            axios.single({
                method: "get",
                url: "/api/customers",
                responseType: "json",
                headers: { 'x-access-token': auth.user["token"] }
            })
        ])
            .then(axios.spread((...res) => {
                setAllBookings(res[0].data);
                setAllDeals(res[1].data);
                setAllResources(res[2].data);
                setCustomers(res[3].data);
                setLoading(false);
            }))
            .catch(err => console.log(err));
    }

    const handleSendInvoices = (selectedIds) => {
        setSelectedItems(selectedIds);
        setShowInvoiceSendModal(true);
        setUpdateTable(updateTable + 1)
        setForceUpdate(forceUpdate + 1);
    }

    useEffect(() => {
        if (auth.user["userdata"] == undefined) { window.location.href = "/login"; }
        fetchData();
    }, [forceUpdate]);

    return (
        <div className="maincontent">
            <div className="bookings-container">
                <Card>
                    <Card.Body>
                        <h4 className="header-title">{t("bookings.title")}</h4>
                        {auth.user["userdata"]["role"][0] === "Admin" &&
                            <Button className="newBookingBtn" disabled={!(allDeals.length > 0 && allDeals.some(d => d["isDefaultDeal"]))} onClick={handleShowNewBooking}>{t("bookings.new")}</Button>
                        }
                        {!(allDeals.length > 0 && allDeals.some(d => d["isDefaultDeal"])) && loading == false &&
                            <p>{t("bookings.missing_default_deal")}</p>
                        }
                        <br />
                        <hr />
                        <p>{t("bookings.filters")}</p>
                        <FilterSelector
                            filtersUrl="/api/filters/bytype/"
                            filterType="bookings"
                            fields={[
                                //{ label: t("bookings.deal"), value: "dealReadable", type: "string" },
                                { label: t("bookings.events"), value: "eventReadable", type: "string" },
                                { label: t("bookings.status"), value: "status", type: "string" },
                                { label: t("bookings.lastname"), value: "lastname", type: "string" },
                                { label: t("bookings.firstname"), value: "firstname", type: "string" },
                                { label: t("bookings.phone"), value: "phone", type: "string" },
                                { label: t("bookings.earlieststarttime"), value: "startDateReadable", type: "date" },
                                { label: t("bookings.latestendtime"), value: "endDateReadable", type: "date" },
                                { label: t("bookings.updatetime"), value: "updatetime", type: "date" },
                            ]}
                            onChange={(filter) => {
                                setBookingsFilter(filter.filters);
                            }}
                            onAddClick={ auth.user["userdata"]["role"][0] === "Admin" ? () => {} : undefined}
                            onEditClick={ auth.user["userdata"]["role"][0] === "Admin" ? () => {} : undefined}
                            onDeleteClick={ auth.user["userdata"]["role"][0] === "Admin" ? () => {} : undefined}
                            addFilterText={t("bookings.addfilter")}
                        ></FilterSelector>
                        <PageTable
                            dataUrl="/api/bookings/getAllPaged/"
                            checkAllUrl="/api/bookings/getAllPaged/checkAll"
                            allDataUrl="/api/bookings"
                            updateCheckedItems="/api/bookings/byids"
                            selectedFunctions={[
                                { label: "SendInvoices", func: (selectedIds) => { handleSendInvoices(selectedIds); /* UseSendSMS function to send to selectedIds */ } },
                                //{ label: "Delete", func: (selectedIds) => { console.log(selectedIds); /* Function here will delete all selectedIds */ } },
                                //{ label: "Archive", func: (selectedIds) => { console.log(selectedIds); /* Function here will archive all selectedIds */ } },
                            ]}
                            options={{
                                showFields: [
                                    { 
                                        label: t("bookings.validinvoice"), 
                                        field: "validinvoice", 
                                        override: (dataline)=> { 
                                            if(dataline.bookingnumber != undefined ? dataline.bookingnumber : ""  ){
                                                const customer = customers.find(c => c._id == dataline.customerId);
                                                if(customer == undefined) {
                                                    return <span><i className="dripicons-warning" style={{color: "red"}}/>  {dataline.validinvoice}</span>;
                                                }
                                                if(customer.companyRegistrationId != undefined && customer.companyRegistrationId != "" ){
                                                    if(
                                                        customer.apArNo == "" ||
                                                        customer.organizationName == "" ||
                                                        customer.companyRegistrationId == "" || 
                                                        customer.firstname == "" || 
                                                        customer.lastname == "" || 
                                                        customer.address == "" || 
                                                        customer.email == "" || 
                                                        customer.phone == "" || 
                                                        customer.relAttrId == "" ||
                                                        customer.apArNo == undefined ||
                                                        customer.organizationName == undefined ||
                                                        customer.companyRegistrationId == undefined || 
                                                        customer.firstname == undefined || 
                                                        customer.lastname == undefined || 
                                                        customer.address == undefined || 
                                                        customer.email == undefined || 
                                                        customer.phone == undefined || 
                                                        customer.relAttrId == undefined

                                                    ){
                                                        return <span><i className="dripicons-warning" style={{color: "red"}}/>  {dataline.validinvoice}</span> 
                                                    
                                                    }else{
                                                        return <span><i className="dripicons-checkmark" style={{color: "green"}}/>  {dataline.validinvoice}</span> 
                                                    }
                                                }
                                                else {
                                                    if(
                                                       customer.firstname == "" || 
                                                       customer.lastname == "" || 
                                                       customer.address == "" || 
                                                       customer.email == "" || 
                                                       customer.phone == "" || 
                                                       customer.firstname == undefined || 
                                                       customer.lastname == undefined || 
                                                       customer.address == undefined || 
                                                       customer.email == undefined || 
                                                       customer.phone == undefined  
                                                       
                                                    ){
                                                        return <span><i className="dripicons-warning" style={{color: "red"}}/>  {dataline.validinvoice}</span> 
                                                    
                                                    }else{
                                                        return <span><i className="dripicons-checkmark" style={{color: "green"}}/>  {dataline.validinvoice}</span> 
                                                    }
                                                }
                                                
                                            }
                                        },
                                        noFilter: ""
                                    },    
                                    //{ label: t("bookings.bookingnumber"), field: "bookingnumber", override: (dataline) => dataline["bookingnumber"] != undefined ? currentDate + "-" + "0000" + dataline["bookingnumber"] : "" },
                                    { label: t("bookings.bookingnumber"), field: "bookingnumber", override: (dataline) => dataline["bookingnumber"] != undefined ? dataline["bookingnumber"] : "" },
                                    { label: t("bookings.organization"), field: "customerOrganization" },
                                    //{ label: t("bookings.deal"), field: "dealReadable" },//, override: (dataline) => dataline["deal"]!= undefined ? ((allDeals.find(i => i["_id"] == dataline["deal"]["_id"]) || { name: "" }) as any)["name"] : ""},
                                    { 
                                        label: t("bookings.status"), 
                                        field: "status",
                                        override: (dataline) => {
                                            switch(dataline.status){
                                                case "new":
                                                    return <span>{t("booking.general.status_new")}</span>;    
                                                
                                                case "inprocess":
                                                    return <span>{t("booking.general.status_inprocess")}</span>;
                                                    
                                                case "completed":
                                                    return <span>{t("booking.general.status_completed")}</span>;
                                                    
                                                case "invoiced":
                                                    return <span>{t("booking.general.status_invoiced")}</span>;
                                                    
                                                default:
                                                    return <span>{dataline.status}</span>;
                                            }
                                        },
                                        customFilters: [
                                            { label: t("booking.general.status_new"), value: "new" },
                                            { label: t("booking.general.status_inprocess"), value: "inprocess" },
                                            { label: t("booking.general.status_completed"), value: "completed" },
                                            { label: t("booking.general.status_invoiced"), value: "invoiced" },
                                        ]
                                    },
                                    { label: t("bookings.events"), field: "eventReadable" },
                                    { label: t("bookings.lastname"), field: "customerLastName" },
                                    { label: t("bookings.firstname"), field: "customerFirstName" },
                                    { label: t("bookings.phone"), field: "customerPhone" },
                                    { 
                                        label: t("bookings.earlieststarttime"), 
                                        field: "startDateReadable", 
                                        override: (dataline) => dataline["startDateReadable"] != "" ? <DateFormatter date={dataline["startDateReadable"]} /> : "",
                                        noFilter: ""
                                    },
                                    { 
                                        label: t("bookings.latestendtime"), 
                                        field: "endDateReadable", 
                                        override: (dataline) => dataline["endDateReadable"] != "" ? <DateFormatter date={dataline["endDateReadable"]} /> : "",
                                        noFilter: ""
                                    },
                                    /*{ 
                                        label: t("bookings.nextupcomingevent"), 
                                        field: "nextUpcomingEventReadable", 
                                        override: (dataline) => dataline["nextUpcomingEventReadable"] != "" ? <DateFormatter date={dataline["nextUpcomingEventReadable"]} /> : "",
                                        noFilter: ""
                                    },
                                    // { label: t("bookings.updatetime"), field: "updatetime", override: (dataline) => dataline["updatetime"] != undefined ? moment(new Date(dataline["updatetime"]).toString()).locale("nb_NO").format("DD.MM.YYYY [kl.] HH.mm"): ""},
                                    { 
                                        label: t("bookings.updatetime"), 
                                        field: "updatetime", 
                                        override: (dataline) => dataline["updatetime"] != undefined ? <DateFormatter date={dataline["updatetime"]} /> : "",
                                        noFilter: ""
                                    },*/
                                ]
                            }}
                            dataAfter={(dataLine) => <Button onClick={(evt) => handleShowDeleteModal(dataLine, evt)}> {t("bookings.delete")} </Button>}
                            onLineClick={(dataLine) => dataLine["accessRule"] != "adminprivate" ? history.push("/booking/" + dataLine["_id"]) : null}
                            hidePagination={false}
                            hidePagesize={false}
                            hideFilter={false}
                            updateTable={updateTable}
                            hover={true}
                            permaFilters={bookingsFilter}
                        />
                    </Card.Body>
                </Card>
                <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {t("bookings.delete")}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>{t("bookings.delete_info")}</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => setShowDeleteModal(false)}>
                            {t("bookings.cancel")}
                        </Button>
                        <Button onClick={handleDeleteBooking}>
                            {t("bookings.delete")}
                        </Button>
                    </Modal.Footer>
                </Modal>
                 <InvoiceSender
                    show={showInvoiceSendModal}
                    onHide={() => setShowInvoiceSendModal(false)}
                    onCancel={() => setShowInvoiceSendModal(false)}
                    onBilling={() => {
                        setShowInvoiceSendModal(false);
                        setUpdateTable(updateTable + 1);
                    }}
                    invoicedBookings={selectedItems}
                    allBookings={allBookings}
                    onSend={() => {
                        setUpdateTable(updateTable + 1);
                        setShowInvoiceSendModal(false);
                    }}
                ></InvoiceSender>
            </div>
        </div>
    );
}

export default Bookings;